import React from 'react';
import { Trans } from 'react-i18next';

export interface ScoreStatusSubReasonsProps {
  scoreStatusSubReasons: string[];
}

export const ScoreStatusSubReasons: React.FC<ScoreStatusSubReasonsProps> = ({ scoreStatusSubReasons }) => {
  return (
    <>
      <div />
      <div className="account-session-candidate__score">
        <div className="account-session-candidate__score-row">
          <p>
            <Trans>account.session.candidate.score-information</Trans>
          </p>
        </div>
        <div className="account-session-candidate__score-row">
          <Trans>account.session.candidate.score-cancelled-for-non-respect-of-procedure</Trans>
        </div>
        <div className="account-session-candidate__score-row">
          <Trans>account.session.candidate.score-cancelled-reason</Trans>
        </div>
        <div className="account-session-candidate__score-row">
          <ul className="account-session-candidate__score-row-list-sub-reason">
            {scoreStatusSubReasons.map((reason, key) => {
              return (
                <li key={key}>
                  <Trans>account.session.candidate.score-status-sub-reason-{reason}</Trans>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};
